export const PROLIFIC_COMPLETION_BASE_URL = 'https://app.prolific.co/submissions/complete';
